import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { uniq } from 'lodash'
import { LocationProductType } from 'app/types/entities'
import { notifySuccess, notifyError } from 'app/services/notify.client'
import { useLocationStore } from 'app/stores/StoreContext'

export type UseSettingsProductsReturn = {
  products: LocationProductType[]
  availableProducts: LocationProductType[]
  toggle: (product: LocationProductType, enabled: boolean) => void
  onSubmit: () => void
}

export function useSettingsProducts(): UseSettingsProductsReturn {
  const { locationId } = useParams()
  const store = useLocationStore()
  const [products, setProducts] = useState<LocationProductType[]>([])

  useEffect(() => {
    if (!locationId) return
    store.fetchOne(locationId).then(() => {
      const loc = store.current as unknown as { products?: LocationProductType[] } | undefined
      setProducts(loc?.products ?? [])
    })
  }, [locationId])

  function toggle(product: LocationProductType, enabled: boolean) {
    if (enabled) {
      setProducts((prev) => uniq([...prev, product]))
    } else {
      setProducts((prev) => prev.filter((p) => p !== product))
    }
  }

  async function onSubmit() {
    if (!locationId) return
    const result = await store.update(locationId, { products })
    if (result) {
      notifySuccess(`Products Saved`)
    } else {
      notifyError(`Failed to save products`)
    }
  }

  return {
    products,
    availableProducts: [`Scheduler`, `AI Agent`, `SMS Agent`, `CRM`, `Call Processing`, `Inbox`],
    toggle,
    onSubmit,
  }
}
